import React from 'react'

const Cross = props => (
  <svg viewBox="0 0 48.76 48.76" {...props}>
    <path
      d="M44.76 48.76a4 4 0 0 1-2.83-1.17L24.38 30 6.83 47.59A4 4 0 0 1 4 48.76a4 4 0 0 1-2.83-1.17 4 4 0 0 1 0-5.66l17.55-17.55L1.17 6.83a4 4 0 0 1 5.66-5.66l17.55 17.55L41.93 1.17a4 4 0 1 1 5.66 5.66L30 24.38l17.59 17.55a4 4 0 0 1 0 5.66 4 4 0 0 1-2.83 1.17z"
      fill={props.color ? props.color : '#fff'}
    />
  </svg>
)

export default Cross



// WEBPACK FOOTER //
// ./src/components/shared/cross.js